import type { DashboardSummary } from "../types";
import { apiFetch } from "./client";
import { canonicalStockyPublicBigIntId } from "./stocky_public_ids";

function normalizeDashboardSummary(value: unknown): DashboardSummary {
  if (value === null || typeof value !== "object" || Array.isArray(value)) {
    throw new TypeError("dashboard response is invalid");
  }
  const summary = value as Omit<DashboardSummary, "shop_id" | "top_sellers"> & {
    shop_id: unknown;
    top_sellers: unknown;
  };
  if (!Array.isArray(summary.top_sellers)) {
    throw new TypeError("dashboard top sellers response is invalid");
  }
  return {
    ...summary,
    shop_id: canonicalStockyPublicBigIntId(summary.shop_id),
    top_sellers: summary.top_sellers.map((value) => {
      if (value === null || typeof value !== "object" || Array.isArray(value)) {
        throw new TypeError("dashboard top seller response is invalid");
      }
      const row = value as Omit<
        DashboardSummary["top_sellers"][number],
        "variant_id" | "shopify_variant_id"
      > & {
        variant_id: unknown;
        shopify_variant_id: unknown;
      };
      return {
        ...row,
        variant_id: canonicalStockyPublicBigIntId(row.variant_id),
        shopify_variant_id:
          row.shopify_variant_id === null
            ? null
            : canonicalStockyPublicBigIntId(row.shopify_variant_id),
      };
    }),
  };
}

export async function getDashboardSummary(
  windowDays = 30,
): Promise<DashboardSummary> {
  return normalizeDashboardSummary(
    await apiFetch<unknown>("/api/dashboard/summary", {
      query: { window_days: windowDays },
    }),
  );
}
